import React from 'react';
import './MaintenancePage.css';

const MaintenancePage = () => {
    return (
        <div className="maintenance-page">
            <div className="maintenance-grad maintenance-grad-1"></div>
            <div className="maintenance-grad maintenance-grad-2"></div>

            <main className="maintenance-content">
                <div className="maintenance-scene">

                    <div className="maintenance-core">
                        <div className="maintenance-core-glow"></div>
                        <svg className="maintenance-svg" viewBox="0 0 24 24"><path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1Z" /></svg>
                    </div>

                    <div className="maintenance-worker maintenance-worker-1">
                        <div className="maintenance-worker-icon" style={{ color: 'var(--purple)' }}>
                            <svg className="maintenance-svg" viewBox="0 0 24 24"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
                        </div>
                        <div className="maintenance-status-tag" style={{ background: 'rgba(168, 85, 247, 0.2)', border: '1px solid rgba(168, 85, 247, 0.3)', color: 'var(--purple)' }}>UI_REFINEMENT</div>
                    </div>

                    <div className="maintenance-worker maintenance-worker-2">
                        <div className="maintenance-worker-icon" style={{ color: 'var(--green)' }}>
                            <svg className="maintenance-svg" viewBox="0 0 24 24"><polyline points="16 18 22 12 16 6" /><polyline points="8 6 2 12 8 18" /></svg>
                        </div>
                        <div className="maintenance-status-tag" style={{ background: 'rgba(34, 197, 94, 0.2)', border: '1px solid rgba(34, 197, 94, 0.3)', color: 'var(--green)', animationDelay: '1s' }}>API_OPTIMIZING</div>
                    </div>

                    <div className="maintenance-worker maintenance-worker-3">
                        <div className="maintenance-worker-icon" style={{ color: 'var(--yellow)' }}>
                            <svg className="maintenance-svg" viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="2" /><path d="m17 17-5-5 5-5" /><path d="m7 7 5 5-5 5" /></svg>
                        </div>
                    </div>
                </div>

                <div className="maintenance-badge">
                    <svg style={{ width: '12px', height: '12px', fill: 'currentColor' }} viewBox="0 0 24 24"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" /></svg>
                    Active Maintenance Mode
                </div>

                <h1 className="maintenance-title">Team is <span className="maintenance-gradient-text">Working</span></h1>

                <p className="maintenance-text">Our technical experts are currently fine-tuning the system to deliver a superior experience. We're building something great for you.</p>


                <div className="maintenance-contact-btn">
                    <div className="maintenance-mail-icon">
                        <svg className="maintenance-svg" viewBox="0 0 24 24"><rect width="20" height="16" x="2" y="4" rx="2" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" /></svg>
                    </div>
                    <div className="maintenance-btn-text">
                        <span className="maintenance-btn-title">Contact Technical Team</span>
                        <span className="maintenance-btn-subtitle">Fast response guaranteed</span>
                    </div>
                </div>
            </main>

            <footer className="maintenance-footer">
                <div className="maintenance-footer-links">
                    <span>Reliability</span>
                    <div className="maintenance-dot"></div>
                    <span>Security</span>
                    <div className="maintenance-dot"></div>
                    <span>Performance</span>
                </div>
                <div style={{ fontSize: '10px', color: '#333' }}>&copy; {new Date().getFullYear()} Weborative. All rights reserved.</div>
            </footer>
        </div>
    );
};

export default MaintenancePage;
